export const enum DeepLinkType {
  UNSUPPORTED_FEATURE = 'UNSUPPORTED_FEATURE',
  SIGN_UP = 'SIGN_UP',
  CONTEST_DETAIL = 'CONTEST_DETAIL',
  REFER_A_FRIEND = 'REFER_A_FRIEND',
}
